import { Skeleton } from "@/components/kit";
import { formatLak } from "@/shared/lib/currency";
import { customJobStatusLabel } from "@/modules/custom-jobs/presentation/ui/job-status";
import type { CustomJobsSummaryDTO } from "@/modules/reports/domain/repo/custom-jobs-summary";

function KpiCard({
  label,
  value,
  hint,
}: {
  label: string;
  value: string;
  hint?: string;
}) {
  return (
    <div className="brand-card px-4 py-3">
      <p className="text-muted-foreground text-sm">{label}</p>
      <p className="font-display text-xl">{value}</p>
      {hint ? (
        <p className="mt-1 text-muted-foreground text-xs">{hint}</p>
      ) : null}
    </div>
  );
}

export function CustomJobsReportPanel({
  data,
  isLoading,
}: {
  data?: CustomJobsSummaryDTO;
  isLoading: boolean;
}) {
  if (isLoading) {
    return (
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-24 rounded-xl" />
        ))}
      </div>
    );
  }

  if (!data) return null;

  return (
    <div className="flex flex-col gap-4">
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        <KpiCard
          label="ງານສົ່ງມອບ"
          value={String(data.completed.jobCount)}
        />
        <KpiCard label="ຍອດຂາຍ" value={formatLak(data.completed.revenue)} />
        <KpiCard
          label="COGS ວັດຖຸດິບ"
          value={formatLak(data.completed.cogsTotal)}
        />
        <KpiCard
          label="ກຳໄລຂັ້ນຕົ້ນ"
          value={formatLak(data.completed.grossMargin)}
          hint={`ສະເລ່ຍ ${formatLak(data.completed.averageJobValue)}/ງານ`}
        />
      </div>

      {data.openByStatus.length > 0 ? (
        <div className="brand-card px-4 py-3">
          <p className="mb-2 font-medium text-sm">ງານຄ້າງ</p>
          <div className="flex flex-wrap gap-2">
            {data.openByStatus.map((row) => (
              <span
                key={row.status}
                className="rounded-full bg-muted px-3 py-1 text-sm"
              >
                {customJobStatusLabel(row.status as never)} · {row.count}
              </span>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
